import { $curSandTable } from '@stores/dataStores';
import { $sandTableLoaded } from '@stores/sandTableStores';
import { SandTableType } from '@types';
import { useStore } from 'effector-react';
import { useEffect, useRef, useState } from 'react';
import {
  SidebarSandTableImage,
  SidebarSandTableImageBatch,
  SidebarSandTableImageGroup,
} from '../SidebarSandTableImage';
import {
  SidebarSandTableMap,
  SidebarSandTableMapBatch,
  SidebarSandTableMapGroup,
} from '../SidebarSandTableMap';
import { backToListMode } from '../actions/backToListMode';

type Mode = 'list' | 'batch' | 'group';

function SidebarSandTable() {
  const isLoaded = useStore($sandTableLoaded);
  const data = useStore($curSandTable);
  const [mode, setMode] = useState<Mode>('list');
  const initialRef = useRef(true);

  useEffect(() => {
    setMode('list');
  }, [data?.id]);

  useEffect(() => {
    return backToListMode.watch(() => {
      setMode('list');
    });
  }, []);

  if (!isLoaded || !data) return null;
  const { type } = data;

  if (type === SandTableType.map) {
    if (mode === 'group') {
      return (
        <SidebarSandTableMapGroup
          data={data}
          onQuitClick={() => {
            initialRef.current = false;
            setMode('list');
          }}
        />
      );
    }
    if (mode === 'batch') {
      return (
        <SidebarSandTableMapBatch
          data={data}
          onQuitClick={() => {
            initialRef.current = false;
            setMode('list');
          }}
        />
      );
    }
    return (
      <SidebarSandTableMap
        data={data}
        isInitial={initialRef.current}
        onBatchClick={() => setMode('batch')}
        onGroupClick={() => setMode('group')}
      />
    );
  }
  if (type === SandTableType.matrix || type === SandTableType.image) {
    if (mode === 'group') {
      return (
        <SidebarSandTableImageGroup
          data={data}
          onQuitClick={() => setMode('list')}
        />
      );
    }
    if (mode === 'batch') {
      return (
        <SidebarSandTableImageBatch
          data={data}
          onQuitClick={() => setMode('list')}
        />
      );
    }
    return (
      <SidebarSandTableImage
        data={data}
        onBatchClick={() => setMode('batch')}
        onGroupClick={() => setMode('group')}
      />
    );
  }
  return null;
}

export default SidebarSandTable;
